import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../firebase/config';
import { logger } from '../../../services/logger';
import {
    fetchAccountData,
    fetchLinkedRegistrations,
    extractActiveProgramIds
} from './useNavbarAuthHelpers';

export function useNavbarAuth() {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isProgramsManager, setIsProgramsManager] = useState(false);
    const [isCommunityMember, setIsCommunityMember] = useState(false);
    const [registeredProgramIds, setRegisteredProgramIds] = useState(new Set());

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if (!currentUser) {
                setIsCommunityMember(false);
                setIsAdmin(false);
                setIsProgramsManager(false);
                setRegisteredProgramIds(new Set());
                return;
            }

            try {
                const accData = await fetchAccountData(currentUser);

                const isAdminUser = accData?.role === 'admin';
                const isProgramsManagerUser = accData?.programsManager === true;
                const isMember = Boolean(
                    accData?.isCommunityMember === 'Yes' ||
                    accData?.role === 'admin' ||
                    accData?.role === 'coach'
                );

                setIsAdmin(isAdminUser);
                setIsProgramsManager(isProgramsManagerUser);
                setIsCommunityMember(isMember);

                const regDocsMap = await fetchLinkedRegistrations(currentUser, accData);
                const activeIds = extractActiveProgramIds(regDocsMap);
                setRegisteredProgramIds(activeIds);
            } catch (e) {
                logger.warn("Error loading account for navbar:", e);
                setIsCommunityMember(false);
                setIsAdmin(false);
                setIsProgramsManager(false);
                setRegisteredProgramIds(new Set());
            }
        });
        return () => unsubscribe();
    }, []);

    return {
        user,
        isAdmin,
        isProgramsManager,
        isCommunityMember,
        registeredProgramIds
    };
}
